import script from "./GeoItemSearchLandAiDetections.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoItemSearchLandAiDetections.vue?vue&type=script&setup=true&lang=ts"

import "./GeoItemSearchLandAiDetections.vue?vue&type=style&index=0&id=fe98ceec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe98ceec"]])

export default __exports__